import React from 'react'
import DuplicateIcon from '@material-ui/icons/FilterNone';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconDuplicateButton(
    {
        tooltip = Tr('duplicate'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={DuplicateIcon}
        {...props}
    />
}

WorkableIconDuplicateButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconDuplicateButton;